<script>
    export let text;
</script>

<p>{text}</p>

<style>
    p {
        font-style:italic;
        color: hsl(0, 0%, 70%);
        font-size: 22px;
        font-weight: 200;
        max-width: 450px;
    }
</style>